import { useState, useEffect, useMemo } from 'react';
import { DynamicError } from '@dynamic-labs/utils';
import { fetchProjectSettings } from '../../../data/api.js';
import '@dynamic-labs/sdk-api';
import '../../../shared/logger.js';
import { getFromLS } from '../../../shared/utils/functions/storage/getFromLS.js';
import '../../../config/LSSuffix.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import { PROJECT_SETTINGS_STORAGE_KEY, CONNECTED_WALLET_CONNECTOR_DATA } from '../../constants/localStorage.js';
import '../../constants/colors.js';
import 'ethers';
import { useLocalStorage } from '../../../shared/utils/hooks/useLocalStorage/useLocalStorage.js';
import '../../../shared/consts/index.js';
import { validateLocalStorageExpiry } from '../../../context/DynamicContext/validators.js';
import '@dynamic-labs/multi-wallet';
import { getEnabledProviders } from '../../functions/getEnabledProviders/index.js';

const useFetchProjectSettings = ({ authToken, environmentId, maxRetries = 2, }) => {
    const [lsSettings, setLsSettings, removeLsSettings] = useLocalStorage(PROJECT_SETTINGS_STORAGE_KEY, undefined, validateLocalStorageExpiry);
    const [isLoading, setLoading] = useState(false);
    const [retries, setRetries] = useState(0);
    const lsSettingsExists = (lsSettings === null || lsSettings === void 0 ? void 0 : lsSettings.settings) !== undefined ? true : false;
    if (lsSettings &&
        lsSettings.environmentId &&
        lsSettings.environmentId !== environmentId) {
        removeLsSettings();
    }
    useEffect(() => {
        const connectedWalletData = getFromLS(CONNECTED_WALLET_CONNECTOR_DATA);
        if (!authToken && !connectedWalletData) {
            removeLsSettings();
        }
    }, [authToken, removeLsSettings]);
    useEffect(() => {
        if (!lsSettingsExists &&
            !isLoading &&
            environmentId &&
            retries < maxRetries) {
            setLoading(true);
            fetchProjectSettings(environmentId)
                .then((response) => {
                if (!response)
                    throw new DynamicError('Settings are not defined');
                const expiry = new Date().getTime() + 60000 * 5;
                setLsSettings({
                    environmentId,
                    expiry: expiry,
                    settings: response,
                });
            })
                .catch(() => {
                setRetries((currentRetries) => currentRetries + 1);
            })
                .finally(() => {
                setLoading(false);
            });
        }
    }, [environmentId, isLoading, lsSettingsExists, maxRetries, retries]);
    const projectSettings = useMemo(() => {
        const settings = lsSettings === null || lsSettings === void 0 ? void 0 : lsSettings.settings;
        if (!settings)
            return;
        if (settings.providers) {
            const enabledProviders = getEnabledProviders(settings.providers);
            return Object.assign(Object.assign({}, settings), { providers: enabledProviders.length > 0 ? enabledProviders : undefined });
        }
        return settings;
    }, [lsSettings === null || lsSettings === void 0 ? void 0 : lsSettings.settings]);
    return { isLoading, projectSettings, removeLsSettings };
};

export { useFetchProjectSettings };
